import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloRecensione } from '@/mocks/articles';

export default function RecensionePage() {
  return <ArticleLayout article={articoloRecensione} />;
}